import React, { useState } from 'react';
import { Button } from './ui/button';
import { Tabs, TabsList, TabsTrigger, TabsContent } from './ui/tabs';
import { Bot, Sparkles, X } from 'lucide-react';
import { ChatPanel } from './ai-chat/ChatPanel';
import { CardTitle } from './ui/card';

const SIDEBAR_WIDTH = 400; // px

const AIChatAgent: React.FC<{ open?: boolean; onOpenChange?: (open: boolean) => void }> = ({ open: controlledOpen, onOpenChange }) => {
  const [internalOpen, setInternalOpen] = useState(false);
  const open = controlledOpen !== undefined ? controlledOpen : internalOpen;
  const setOpen = onOpenChange || setInternalOpen;
  const [tab, setTab] = useState('chat');

  // Only show on desktop
  const isDesktop = typeof window !== 'undefined' ? window.innerWidth >= 1024 : true;
  if (!isDesktop) return null;

  return (
    <>
      {/* Floating Chat Button (hide when sidebar is open) */}
      {!open && (
        <div style={{
          position: 'fixed',
          bottom: 24,
          right: 24,
          zIndex: 1000,
        }}>
          <Button size="icon" variant="default" onClick={() => setOpen(true)} aria-label="Open AI Chat Agent">
            <Sparkles className="h-6 w-6" />
          </Button>
        </div>
      )}

      {/* Sidebar Panel */}
      {open && (
        <div
          className="fixed top-0 right-0 h-full bg-white dark:bg-gray-900 shadow-lg border-l flex flex-col"
          style={{ width: SIDEBAR_WIDTH, zIndex: 1000 }}
        >
          <div className="flex items-center justify-between px-4 py-3 border-b">
            <h2 className="text-lg font-semibold">AI Chat & Agent</h2>
            <Button size="icon" variant="ghost" onClick={() => setOpen(false)} aria-label="Close">
              <X className="w-5 h-5" />
            </Button>
          </div>
          <ChatPanel />

          {/* <Tabs value={tab} onValueChange={setTab} className="flex-1 flex flex-col overflow-hidden">
            <TabsList className="flex px-4 pt-2 pb-0 gap-2">
              <TabsTrigger value="chat">Chat</TabsTrigger>
              <TabsTrigger value="history">History</TabsTrigger>
              <TabsTrigger value="agents">Agents</TabsTrigger>
            </TabsList>
            <div className="flex-1 overflow-y-auto px-4 pb-4">
              <TabsContent value="chat">
                <ChatPanel />
              </TabsContent>
              <TabsContent value="history">
                <div className="mt-4 text-sm text-gray-500">No previous conversations yet.</div>
              </TabsContent>
              <TabsContent value="agents">
                <div className="mt-4 text-sm text-gray-500">Available agents: Analytics, Reports, Data Query, Program Insights (mock)</div>
              </TabsContent>
            </div>
          </Tabs> */}
        </div>
      )}
    </>
  );
};

export default AIChatAgent; 